import * as React from "react";
import {authorize} from "@athena-portal/components";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {RouteComponentProps} from "react-router";
import {ClaimReportingPopup} from "../../../../../components/claims/ClaimReportingPopup";
import {getSessionStorage, setSessionStorage} from "../../../../../CommonFunctions";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {NextButton} from "./NextButton";
import {RadioInput} from "../../../../../components/inputs/RadioInput";
import {FalconNavigatorHeader} from "@falcon/services";

interface IProps extends RouteComponentProps<{}> {}

interface IUrgentClaimPageState {
    urgentClaim: IUrgentClaim;
}

export interface IUrgentClaim {
    isUrgentClaim: boolean | null;
    showUrgentClaimPopup: boolean;
}

@authorize
export class UrgentClaimPage extends React.Component<IProps, IUrgentClaimPageState> {

    private pluginTemplates = new PluginTemplates();

    private static readonly URGENT_CLAIM_TITLE_TEXT: string = "Urgent claim reporting";
    private static readonly URGENT_CLAIM_FIRST_PARAGRAPH: JSX.Element = <p>If you're on the roadside, your vehicle is not drivable or any{' '}
    one has been injured please call our urgent claims number on</p>;

    constructor(props: IProps) {
        super(props);

        const urgentClaim = getSessionStorage("urgentClaim");

        this.state = {
            urgentClaim: urgentClaim !== null ? urgentClaim : {
                isUrgentClaim: null,
                showUrgentClaimPopup: false
            } as IUrgentClaim
        };
        this.pluginTemplates.setPageTitle("Make a car claim");
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>

                <div className="page-contents">
                    {this.state.urgentClaim.showUrgentClaimPopup &&
                        <ClaimReportingPopup title={UrgentClaimPage.URGENT_CLAIM_TITLE_TEXT}
                             bodyTopParagraph={UrgentClaimPage.URGENT_CLAIM_FIRST_PARAGRAPH}
                             showModal={this.state.urgentClaim.showUrgentClaimPopup}
                             onModalHide={this.toggleModal}
                             id={"urgentClaimReporting"}
                             localPhoneNumber="08000 304 897"
                             abroadPhoneNumber="0120 284 8509"
                        />
                    }
                    <FalconNavigatorHeader back="/dashboard/windscreen" title="Make a car claim"/>
                    {this.renderClaimUrgentSection()}
                    {this.state.urgentClaim.isUrgentClaim === false &&
                        <NextButton buttonId={"submitUrgentClaimPage"}
                            disabled={false}
                            onClick={this.handleRedirect}/>
                    }
                    <BackButton isTop={false}/>
                </div>

                <FalconFooter/>
            </React.Fragment>
        )
    }

    private renderClaimUrgentSection = (): JSX.Element => {
        return (
            <React.Fragment>
                <div className="panel">
                    <RadioInput label={<label>Is your claim urgent?</label>}
                        id="urgentClaim"
                        onChange={this.setUrgentClaim}
                        value={this.state.urgentClaim.isUrgentClaim!}
                        infoSection={this.renderUrgentClaimInfoSection()}
                        inlineDisplay={true}
                    />
                </div>
            </React.Fragment>
        )
    };

    private renderUrgentClaimInfoSection(): React.ReactNode {
        return (
            <div className="info-button-panel">
                <p>
                    <b>Urgent claim: </b>
                    If you're on the roadside, your vehicle is not drivable or any one has been injured please call our urgent claims number on
                    <b>
                        <a href="tel:+44 8000 304 897" className="mb-4 no-underline text-blue-2" aria-label="Phone number +44 8000 304 897"> 08000 304 897</a>
                    </b>
                </p>
                <p>
                    <b>Non-urgent claim: </b>
                    If your vehicle is still drivable and no one has been injured then please use our online notification form
                </p>
            </div>
        )
    }

    private handleRedirect = (): void => {
        this.props.history.push("/dashboard/windscreen/urgent/coverDetails");
    };

    private setUrgentClaim = (event: any): void => {
        const state: boolean = event.target.value === "true";
        const urgentClaim: IUrgentClaim = {...this.state.urgentClaim};
        if (state)  {
            urgentClaim.showUrgentClaimPopup = state;
        }
        urgentClaim.isUrgentClaim = state;
        this.setState({urgentClaim});
        setSessionStorage("urgentClaim", urgentClaim);
    };

    private toggleModal = (): void => {
        const urgentClaim: IUrgentClaim = {...this.state.urgentClaim};
        urgentClaim.showUrgentClaimPopup = !urgentClaim.showUrgentClaimPopup;
        this.setState({urgentClaim});
        setSessionStorage("urgentClaim", urgentClaim);
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/motor/motorClaims/UrgentClaimPage.tsx